import { BackrsFormValues } from '@backrs_ui/common-ui';

const USER_FIELDS: (keyof BackrsFormValues)[] = [
  'first_name',
  'last_name',
  'phone',
  'email',
  'password',
  'grade',
  'school',
  'invite_code',
  'zip_code',
  'onboarding_type',
];

/**
 * Extracts the user data fields from the form data. This is just to get fields we should post to the user endpoint.
 */
export const extractUserDataFromForm = (formData: BackrsFormValues): Partial<BackrsFormValues> => {
  const userData: Partial<BackrsFormValues> = {};

  (Object.entries(formData) as [keyof BackrsFormValues, string][]).forEach(([key, value]) => {
    if (USER_FIELDS.includes(key)) {
      userData[key] = value;
    }
  });

  return userData;
};
